/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// React core.
import React from 'react';
import ReactDOM from 'react-dom';

// Firebase.
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

// Styles
import styles from './app.css'; // This uses CSS modules.
import './firebaseui-styling.global.css'; // Import globally.

// Get the Firebase config from the auto generated file.
const firebaseConfig = require('./firebase-config.json').result.sdkConfig;

// Instantiate a Firebase app.
const firebaseApp = firebase.initializeApp(firebaseConfig);

/**
 * The Splash Page containing the login UI.
 */
class App extends React.Component {
  uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // 'apple.com',
      // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => false,
    },
    tosUrl: 'https://heckle.app/tos',
    privacyPolicyUrl: 'https://heckle.app/privacy',
  };

  state = {
    isSignedIn: undefined,
  };

  /**
   * @inheritDoc
   */
  componentDidMount() {
    this.unregisterAuthObserver = firebaseApp.auth().onAuthStateChanged((user) => {
      this.setState({isSignedIn: !!user});
      console.log(user.providerId);
    }, (error) => {
      console.log(error);
    });
  }

  /**
   * @inheritDoc
   */
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  sendPasswordResetEmail() {
    firebaseApp.auth().sendPasswordResetEmail(firebaseApp.auth().currentUser.email)
    .then(function() {
      console.log('Email sent');
      window.alert('An email has been sent to you with a link to create/reset your password for email login');
    })
    .catch(function(error) {
      console.log(error);
      window.alert('Failed - please try again later or contact support');
    });
  }

  /**
   * @inheritDoc
   */
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.logo}>
          <i className={styles.logoIcon + ' material-icons'}>photo</i> Heckle Live Streaming
        </div>
        <div className={styles.caption}>Web login test</div>
        {this.state.isSignedIn !== undefined && !this.state.isSignedIn &&
          <div>
            <StyledFirebaseAuth className={styles.firebaseUi} uiConfig={this.uiConfig}
                                firebaseAuth={firebaseApp.auth()}/>
          </div>
        }
        {this.state.isSignedIn &&
          <div className={styles.signedIn}>
            Hello {firebaseApp.auth().currentUser.email}.
	    {firebaseApp.auth().currentUser.emailVerified &&
	     <div>Email is verified</div>
	    }
	    {firebaseApp.auth().currentUser.email && firebaseApp.auth().currentUser.providerId == 'twitter.com' &&
	     <a className={styles.button} onClick={() => this.sendPasswordResetEmail()}>Convert account to email login</a>
	    }
	    {firebaseApp.auth().currentUser.email && firebaseApp.auth().currentUser.providerId !== 'twitter.com' &&
	     <a className={styles.button} onClick={() => this.sendPasswordResetEmail()}>Reset password</a>
	    }
            <p>
              <a className={styles.button} onClick={() => firebaseApp.auth().signOut()}>Logout</a>
            </p>
          </div>
        }
      </div>
    );
  }
}

// Load the app in the browser.
ReactDOM.render(<App/>, document.getElementById('app'));
